import styled from 'styled-components';
// Refactor >>>>>>>>>> Remove Inner-sidebar-main styles
export const Inner = styled.div`
  /* max-width: 1020px; */
  /* max-width: ${props => props.theme.maxWidthSingle}; */
  max-width: ${props => {
    return props.narrow ? props.theme.maxWidthSingle : '1020px';
  }};
  margin: 0 auto;
  @media (max-width: 800px) {
    padding: 1.5rem;
  }
`;

export const TextSide = styled.div`
  margin: 0 auto;
  padding: 2rem 0;
  display: grid;
  grid-gap: ${props => {
    return props.narrow ? '20px' : '45px';
  }};
  grid-template-columns: ${props => {
    return props.narrow ? '1fr 250px' : '1fr 300px';
  }};
  @media (max-width: 850px) {
    display: block;
  }
`;

export const TextContainerStyles = styled.div`
  margin: 2rem auto 4rem;
  line-height: 1.5;
  img {
    max-width: 100%;
    object-fit: cover;
    margin: 10px 0;
    }
  p {
    margin: 10px 0;
  }
  a {
    border-bottom: 2px solid #FF0000;
  }
`; 


